export default __webpack_public_path__ + "static/solution-grow.url-7bbaca0fd8366c9acedd5a55d54101f8.svg";